import { Controller } from "@hotwired/stimulus"

// Handles experimental feature toggles without page reload
export default class extends Controller {
  static values = { strategyUuid: String }

  toggle(event) {
    event.stopPropagation()

    const checkbox = event.target
    checkbox.blur() // Prevent focus-induced scroll

    const feature = checkbox.dataset.feature
    const enabled = checkbox.checked

    this.saveFeatureState(feature, enabled)
  }

  async saveFeatureState(feature, enabled) {
    const response = await fetch(`/app/strategies/${this.strategyUuidValue}/toggle_experimental`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "text/vnd.turbo-stream.html",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
      },
      body: JSON.stringify({ feature: feature, enabled: enabled })
    })

    if (!response.ok) {
      console.error("Failed to save experimental feature state")
      return
    }

    // Process Turbo Stream response if present
    const contentType = response.headers.get("Content-Type")
    if (contentType?.includes("text/vnd.turbo-stream.html")) {
      const html = await response.text()
      // Turbo is available globally via @hotwired/turbo-rails import in application.js
      const Turbo = window.Turbo || globalThis.Turbo
      if (Turbo && Turbo.renderStreamMessage) {
        Turbo.renderStreamMessage(html)
      }
    }
  }
}

